<template>
  <div class="sparkline-wrapper">
    <v-sparkline
      :labels="etiquetas"
      :value="valores"
      :color="color"
      line-width="2"
      padding="8"
      :gradient="gradient"
      :smooth="radius || false"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      auto-draw
      class="dark-sparkline"
    ></v-sparkline>

    <div class="sparkline-text">
      <div class="sparkline-title">{{ titulo }}</div>
      <div class="sparkline-subtitle">{{ subtitulo }}</div>
    </div>
  </div>
</template>
<script>

const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea'],
]
export default {
  name: "SparklineComponent",
  props: ["etiquetas", "valores", "color", "titulo", "subtitulo"],
  data: () => ({
    width: 2,
    radius: 10,
    padding: 8,
    lineCap: 'round',
    value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
    fill: false,
    type: 'trend',
    autoLineWidth: false,
    gradientDirection: 'to right',
  }),
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

.sparkline-wrapper {
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --card-border: #26262A;

  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;

  font-family: var(--font-body);
}

.sparkline-text {
  padding-top: 10px;
  margin-top: 6px;
  border-top: 1px solid var(--card-border);
}

.sparkline-title {
  font-size: 12.5px;
  color: var(--text-secondary);
}

.sparkline-subtitle {
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--text-tertiary);
  margin-top: 2px;
}

/* ===== Overrides v-sparkline ===== */
.dark-sparkline >>> .v-sparkline__labels {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/SparklineComponent.vue